import { Link } from "react-router-dom";

const ViewAllHeader = ({ title, to }) => {
  return (
    <div className="flex items-center justify-between mb-6 border-b-2 border-gray-200 pb-3">
      {/* LEFT SIDE - TITLE */}
      <div className="flex items-center gap-3">
        <div className="w-2 h-8 bg-purple-700 rounded-full"></div>
        <h2 className="text-2xl font-black text-[#4600a3] tracking-wide">
          {title}
        </h2>
      </div>

      {/* RIGHT SIDE - VIEW ALL BUTTON */}
      {to && (
        <Link
          to={to}
          className="group flex items-center gap-2 text-sm font-bold text-white bg-brand-purple hover:text-brand-red transition px-4 py-1.5 rounded-full shadow-sm"
        >
          सभी देखें <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
        </Link>
      )}
    </div>
  );
};

export default ViewAllHeader;
